<div class="container-fluid">

    <h4 id="upper">Mission / Recommandation</h4>

    <div class="d-flex justify-content-end">
        <!-- Ajout des champs de date -->
        <div class="me-3">
            <label class="d-inline-flex align-items-center">
                Début:
                <input type="date" class="form-control ms-2" [(ngModel)]="dateDebut" (change)="applyGlobalFilter()">
            </label>
        </div>

        <div class="me-3">
            <label class="d-inline-flex align-items-center">
                Fin:

                <input type="date" class="form-control ms-2" [(ngModel)]="dateFin" (change)="applyGlobalFilter()">
            </label>
        </div>

        <!-- Selectbox pour Direction -->
        <div class="me-3">
            <div id="tickets-table_filter" class="dataTables_filter">
                <label class="d-inline-flex align-items-center">
                    Type mission:
                    <select style="width: 200px;" type="text" name="searchTerm"  (change)="applyGlobalFilter()"class="form-select ms-2"
                        aria-controls="tickets-table" [(ngModel)]="selectedMission">
                        <option disabled value="Sélectionner un   type de mission"></option>
                        <option *ngFor="let item of typemissionItems" [value]="item.id"> {{ item?.libelle}}
                        </option>
                    </select>
                </label>
            </div>
        </div>

        <div class=" col-md-">
            <div id="tickets-table_filter" class="dataTables_filter text-md-end"><label
                    class="d-inline-flex align-items-center">Rechercher:
                    <input [(ngModel)]="searchTerm" type="text" name="searchTerm"
                        class="form-control form-control-sm ms-2" aria-controls="tickets-table" placeholder="Libellé"
                        (keyup)="applyFilter($event.target.value)" (input)="applyFilter($event.target.value)"></label>
            </div>
        </div>

    </div>
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="col-auto">
                        <a href="javascript:void(0);" class="btn btn-success mb-2" id="gras" (click)="openModal()">
                            <i class="mdi mdi-plus me-2"></i> Ajouter une mission
                        </a>
                    </div>
                    <div class="row mb-md-2">
                        <div class="col-sm-12 col-md-6">

                        </div>
                        <!-- Search -->

                        <!-- End search -->
                    </div>
                    <div class="table-responsive mt-3">
                        <table class="table table-centered datatable dt-responsive nowrap"
                            style="border-collapse: collapse; border-spacing: 0; width: 100%;">
                            <thead class="thead-light rwd-table">
                                <tr>
                                    <th>Libellé</th>
                                    <th>Type mission</th>
                                    <th>Début</th>
                                    <th>Fin</th>
                                    <th>Objet</th>

                                    <th style="width: 120px;">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of paginatedItems; let index = index">
                                    <td>{{ item?.libelle }}</td>
                                    <td>{{ item?.type_mission?.libelle }}</td>
                                    <td>{{ item?.date_debut | dateFormat }}</td>
                                    <td>{{ item?.date_fin | dateFormat }}</td>
                                    <td>{{ item?.objet }}</td>

                                    <td>

                                        <a (click)="Recommandation(item)" style="cursor: pointer;"
                                            class="me-3 text-primary" title="Recommandation">
                                            <i class="mdi mdi-plus font-size-18"></i>
                                        </a>
                                        <a (click)="editModal(item)" style="cursor: pointer;" class="me-3 text-primary"
                                            title="Modifier">
                                            <i class="mdi mdi-pencil font-size-18"></i>
                                        </a>
                                        <a (click)="confirmDeletion(item)" href="javascript:void(0);"
                                            class="text-danger" title="Supprimer">
                                            <i class="mdi mdi-trash-can font-size-18"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>



                    </div>
                </div>
                <div class="d-flex justify-content-center" *ngIf="isLoading === true">
                    <div class="container">
                        <div class="row">
                            <div class="text-center">
                                <h5 id="graycolor">Chargement en cours</h5>
                                <div class="loader4"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="paginatedItems.length === 0 && isLoading === false" class="d-flex justify-content-center">
                    <div class="container">
                        <div class="row">
                            <div class="text-center">
                                <h5 id="graycolor">Aucune donnée trouvée</h5>
                            </div>
                        </div>
                    </div>

                </div>
                <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
                    [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
                </p-paginator>
            </div>

        </div>
    </div>
</div>

<ng-template #missionModal let-modal>
    <!-- Contacts model  -->
    <div class="modal-header">
        <h5 class="modal-title">Ajouter une mission</h5>
        <button type="button" class="close" aria-label="Close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-3">
        <div class="text-left">
            <form (ngSubmit)="addMission()">

                <div class="row">
                    <!-- Libellé -->
                    <div class="mb-3 col-md-6">
                        <label for="libelle" class="form-label">
                            Libellé <span class="text-danger">*</span>
                        </label>
                        <input type="text" id="libelle" name="libelle" class="form-control" [(ngModel)]="item.libelle"
                            required />
                    </div>
                    <!-- Type de mission -->
                    <div class="mb-3 col-md-6">
                        <label for="type_mission" class="form-label">
                            Type de mission <span class="text-danger">*</span>
                        </label>
                        <select id="type_mission" name="type_mission" class="form-control"
                            [(ngModel)]="item.type_mission_id" required>
                            <option *ngFor="let type of typemissionItems" [value]="type.id">{{ type.libelle }}</option>
                        </select>
                    </div>

                </div>

                <div class="row">
                    <!-- Structures associées -->
                    <!-- Date d'échéance -->
                    <div class="mb-3 col-md-6">
                        <label for="date_debut" class="form-label">
                            Date début <span class="text-danger">*</span>
                        </label>
                        <input type="date" id="date_debut" name="date_debut" class="form-control"
                            [(ngModel)]="item.date_debut" required />
                    </div>
                    <div class="mb-3 col-md-6">
                        <label for="date_fin" class="form-label">
                            Date de fin <span class="text-danger">*</span>
                        </label>
                        <input type="date" id="date_fin" name="date_fin" class="form-control"
                            [(ngModel)]="item.date_fin" required />
                    </div>


                </div>

                <div class="row">

                    <div class="mb-3 col-md-6">
                        <label for="service_id" class="form-label">
                            Objet <span class="text-danger">*</span>
                        </label>
                        <input type="text" id="objet" name="objet" class="form-control" [(ngModel)]="item.objet"
                            required />
                    </div>
                </div>

                <!-- Boutons -->
                <div class="text-end">
                    <button (click)="close()" type="button" class="btn btn-light ms-1">
                        <i class="pi pi-times" style="color: #212529"></i> Annuler
                    </button>&nbsp;

                    <button type="submit" class="btn btn-success">
                        <i class="pi pi-save" style="color: white"></i> Enregistrer
                    </button>
                </div>
            </form>

        </div>
    </div>


</ng-template>

<!-- edition -->
<ng-template #editModalMission let-modal>
    <!-- Contacts model  -->
    <div class="modal-header">
        <h5 class="modal-title">Modifier une mission</h5>
        <button type="button" class="close" aria-label="Close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-3">
        <div class="text-left">
            <form (ngSubmit)="updateMission()">

                <div class="row">
                    <!-- Libellé -->
                    <div class="mb-3 col-md-6">
                        <label for="libelle" class="form-label">Libellé</label>
                        <input type="text" id="libelle" name="libelle" class="form-control" [(ngModel)]="item.libelle"
                            required />
                    </div>
                    <!-- Type de mission -->
                    <div class="mb-3 col-md-6">
                        <label for="type_mission" class="form-label">Type de mission</label>
                        <select id="type_mission" name="type_mission" class="form-control"
                            [(ngModel)]="item.type_mission_id" required>
                            <option *ngFor="let type of typemissionItems" [value]="type.id">{{ type.libelle }}</option>
                        </select>
                    </div>

                </div>

                <div class="row">
                    <!-- Structures associées -->
                    <!-- Date d'échéance -->
                    <div class="mb-3 col-md-6">
                        <label for="date_debut" class="form-label">Date début</label>
                        <input type="date" id="date_debut" name="date_debut" class="form-control"
                            [(ngModel)]="item.date_debut" required />
                    </div>
                    <div class="mb-3 col-md-6">
                        <label for="date_fin" class="form-label">Date de fin</label>
                        <input type="date" id="date_fin" name="date_fin" class="form-control"
                            [(ngModel)]="item.date_fin" required />
                    </div>


                </div>

                <div class="row">

                    <div class="mb-3 col-md-6">
                        <label for="service_id" class="form-label">Objet</label>
                        <input type="text" id="objet" name="objet" class="form-control" [(ngModel)]="item.objet"
                            required />
                    </div>
                </div>

                <!-- Boutons -->
                <div class="text-end">
                    <button (click)="close()" type="button" class="btn btn-light ms-1">
                        <i class="pi pi-times" style="color: #212529"></i> Annuler
                    </button>&nbsp;

                    <button type="submit" class="btn btn-success">
                        <i class="pi pi-save" style="color: white"></i> Enregistrer
                    </button>
                </div>
            </form>

        </div>
    </div>


</ng-template>

<ngx-ui-loader></ngx-ui-loader>

<p-confirmDialog />
<p-toast />